"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("../util");
const { POST } = util_1.httpMethods;
/**
 * @classdesc Represents the class interfacing node-touch related API-I endpoints
 * @class
 */
class ImagesUpload {
    constructor(api) {
        this.api = api;
    }
    /**
     * Get properties according to the parameters provided
     *
     * @see {@link https://noc2-stage.semios.com/api-internal-docs#images-upload-node-images-post}
     * @param {Object} args={} - An object containing the arguments accepted by the API
     * @param {!number} args.customerId - Required. The id of customer
     * @param {!string} args.contentType - Required. the content type of the images
     * @param {!string[]} args.files - Required. The image filenames
     * @return {promise} Assets - Returns a Promise that, when fulfilled, will either return an array of data or an error with the problem.
     */
    async getPreSignedUrlNode(args) {
        const { customerId, contentType, files } = args || {};
        const methodName = 'getPreSignedUrlNode';
        // validate
        const validations = [
            (0, util_1.validateParam)(methodName, 'customerId', customerId, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'customerId', customerId, util_1.ValidationTypes.INTEGER),
            (0, util_1.validateParam)(methodName, 'contentType', contentType, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'contentType', contentType, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'files', files, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'files', files, util_1.ValidationTypes.ARRAY, util_1.ValidationTypes.OBJECT),
        ];
        (0, util_1.validateParams)(validations);
        const route = 'images/node';
        const input = {
            header: {
                customerId,
            },
            body: {
                contentType,
                files,
            },
        };
        const formattedInput = (0, util_1.setFormattedInput)(input);
        return this.api.send(POST, route, formattedInput);
    }
    /**
     * Get properties according to the parameters provided
     *
     * @see {@link https://noc2-stage.semios.com/api-internal-docs#images-upload-node-service-issue-images-post}
     * @param {Object} args={} - An object containing the arguments accepted by the API
     * @param {!number} args.customerId - Required. The id of customer
     * @param {!string} args.contentType - Required. the content type of the images
     * @param {!Object[]} args.files - Required. The image filenames
     * @return {promise} Assets - Returns a Promise that, when fulfilled, will either return an array of data or an error with the problem.
     */
    async getPreSignedUrlServiceIssue(args) {
        const { customerId, contentType, files } = args || {};
        const methodName = 'getPreSignedUrlServiceIssue';
        // validate
        const validations = [
            (0, util_1.validateParam)(methodName, 'customerId', customerId, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'customerId', customerId, util_1.ValidationTypes.INTEGER),
            (0, util_1.validateParam)(methodName, 'contentType', contentType, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'contentType', contentType, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'files', files, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'files', files, util_1.ValidationTypes.ARRAY, util_1.ValidationTypes.OBJECT),
        ];
        (0, util_1.validateParams)(validations);
        const route = 'images/node_service_issue';
        const input = {
            header: {
                customerId,
            },
            body: {
                contentType,
                files,
            },
        };
        const formattedInput = (0, util_1.setFormattedInput)(input);
        return this.api.send(POST, route, formattedInput);
    }
}
exports.default = ImagesUpload;
//# sourceMappingURL=images-upload.js.map